import { useMediaQuery } from 'react-responsive';
import theme from '../../../../assets/stylesheets/_settings.global.scss';

export default function CommonProps() {
  const mediaQueries = {
    isMobileOrTablet: useMediaQuery({ query: `(max-width: ${theme.breakpointMediumMax})` }),
  };

  return {
    ...theme,
    ...mediaQueries,
  };
}
